<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2021 (original work) Open Assessment Technologies SA ;
    import Warning from './presets/WarningRibbon.svelte';
    import Loading from './presets/LoadingRibbon.svelte';
    import Submit from './presets/SubmitRibbon.svelte';
    import { onMount } from 'svelte';
    import { breakpoints } from '@oat-sa-private/ui-identity';

    const RibbonTypes = {
        warning: Warning,
        loading: Loading,
        submit: Submit
    };

    export let message = '';
    export let type;
    export let icon;
    export let buttonProps;
    let windowWidth;

    onMount(() => {
        if (type === 'submit') {
            checkIfMessageIsWrapped();
        }
    });

    /**
     * Ribbon component requires, on ribbons of tpye submit, to change flex-direction from row to column
     * when message text wraps. Until css container queries are implemented, need to be done on JS.
     * This function compares ribbon content width with max allowed width, and sets wrapped
     * class if necessary. max allowed width can be a computed value declared on css
     * ribbon-content selector (71rem) or its full parent width, on medium designs
     */
    function checkIfMessageIsWrapped() {
        const ribbonContainer = document.getElementsByClassName('ribbon')[0];
        const ribbonContentContainer = document.getElementsByClassName('ribbon-content')[0];
        let maxWidth;

        // On medium design (max-width 767px) maxWidth to compare with will be parent width, on larger designs will be computed max-width
        if (windowWidth < breakpoints.width.medium) {
            maxWidth = ribbonContainer.offsetWidth;
        } else {
            maxWidth = parseInt(window.getComputedStyle(ribbonContentContainer).maxWidth);
        }

        // content is wrapped if its width is equal to maxWidth value
        const isWrapped = ribbonContentContainer.offsetWidth >= maxWidth;

        // if wrapped, add class to change flex-direction to column
        if (isWrapped) {
            ribbonContentContainer.classList.add('wrapped');
        }
    }
</script>

<style>
    .ribbon {
        @add-mixin flex-center-center;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 2rem 0;
        text-align: center;
        min-height: 8.5rem;
        z-index: calc(var(--layer-4) - 1);
    }
    .warning {
        background-color: var(--color-bg-warning);
    }
    .submit {
        background-color: var(--color-brand);
    }
    .loading {
        background-color: var(--color-bg-info);
    }
    .ribbon-content {
        @add-mixin flex-center-center;
        padding: 0 2rem;
        max-width: 71rem;
    }
    .wrapped {
        flex-direction: column;
    }
    :global(.ribbon .ribbon-message) {
        margin: 0 2rem;
        text-align: initial;
    }
    /* mobile, check @checkIfMessageIsWrapped if this media query is updated */
    @media screen and (--mq-maxwidth-medium) {
        .ribbon-content {
            max-width: 100%;
        }
    }
</style>

<svelte:window bind:innerWidth={windowWidth} />

<div class="ribbon {type}" class:inverted={type !== 'loading'}>
    <div class="ribbon-content">
        {#if type}
            <svelte:component this={RibbonTypes[type]} {message} {icon} {buttonProps} on:click />
        {:else}
            <slot />
        {/if}
    </div>
</div>
